// Import modules
import Navigation from 'modules/_navigation'
import ObjectFit from 'modules/_object-fit'
import Print from 'modules/_print'
import WidgetPreview from 'modules/_widget-preview'
import TextMorph from 'modules/_text-morph'
import SlideToggle from 'modules/_slide-toggle'
import VideoModal from 'modules/_video-modal'
import ModalInit from 'modules/_modal'

// Use modules
Navigation()
ObjectFit()
Print()
WidgetPreview()
TextMorph()
SlideToggle()
VideoModal()
ModalInit()

/**
 * If you want to use React in this project, just use the function below:
 * require('./app');
 */